import { Navigate } from "react-router-dom";
import { homeFor, useAuth } from "@/context/AuthContext";

export const Protected = ({ allow, children }) => {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex min-h-screen items-center justify-center" data-testid="auth-loading">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-indigo-600 border-t-transparent" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!allow(user)) return <Navigate to={homeFor(user)} replace />;
  return children;
};

export const isSuper = (u) => u.platform_role === "superadmin" && !u.impersonating;
export const isAdmin = (u) => !!u.business_id && u.tenant_role === "admin";
export const isMember = (u) => !!u.business_id;
